import React from 'react'
import './Skill.css'
import VisibilitySensor from "react-visibility-sensor";
import { CircularProgressbar,  buildStyles} from 'react-circular-progressbar';

function skill({name, prcntg}) {
    return (
        <div className="skill">
          <h2>{name}</h2>
            <VisibilitySensor>
                {({ isVisible }) => {
                const percentage = isVisible ? prcntg : 0;
                return (
                    <CircularProgressbar
                    text={percentage+"%"}
                    className="progBar"
                    value={percentage}
                    styles={buildStyles({
                        pathColor: "white", trailColor: "#100f38", textColor: "white", textSize: 30
                        })}
                />
              );
            }}
          </VisibilitySensor>
        </div>
    )
}

export default skill
